import React, { Component } from 'react';
import './styles.css';

class GreenCentralCircle extends Component {
	render() {
		return (
			<div className="submission-stepper-item-layout-green-central-circle">
				{this.props.children}
			</div>
		);
	}
}

export default GreenCentralCircle;
